import React, { useState, useEffect } from 'react';
import { Table, Dropdown, Menu, Space, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { createNewBBS } from '../../../dashboard/redux/slice.js';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

const VisualizationTable = ({ bbsAlgorithmResult, optimizationDate }) => {
  console.log('bbsAlgorithmResult@@@@@@sdfsdfsdf:', bbsAlgorithmResult);
  // const optimizationDate = dayjs().format('YYYY-MM-DD');
  const [filteredData, setFilteredData] = useState([]);
  const [diameterFilter, setDiameterFilter] = useState('');
  const location = useLocation();

  const { step, project_code, bbs_id } = location.state || {};
  const { newBBSData } = useSelector((state) => state.projectList);
  console.log('newbbsdata: ', newBBSData);

  //const optimizationDates = newBBSData?.RequestApproval?.BBs?.map((item) => item.optimization_date) || [];
  // console.log('opddates: ',newBBSData.optimizationDates)

  console.log('Step:', step);
  console.log('Project Code from previous state:', project_code);
  console.log('BBS ID from previous state:', bbs_id);
  const VisualizationBar = ({ data, optimizationDate, diameter }) => {
    const total = data?.reduce((sum, item) => sum + item, 0);
    let lastCutLength = null;
    let colorIndex = 0;

    const colors = [
      '#FFB0B0',
      '#FFD09B',
      '#FFECC8',
      '#A7D397',
      '#6EB5FF',
      '#FFC300',
    ];

    return (
      <div className="flex w-[1200px] h-12 ">
        {data?.map((item, index) => {
          const isWaste = index === data.length - 1;
          if (item !== lastCutLength) {
            colorIndex = (colorIndex + 1) % colors.length;
            lastCutLength = item;
          }
          if (isWaste && item === 0) return null;

          return (
            <div
              key={index}
              style={{
                backgroundColor: isWaste ? 'gray' : colors[colorIndex],
                width: `${(item / total) * 100}%`,
                flexShrink: 0, // Prevent shrinking
                minWidth: '50px', // Ensures elements have enough space
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#101828',
                fontSize: '7px',
                borderRight: '1px solid grey',
              }}
              className={`flex flex-col justify-between px-2 ${
                data.length === 1
                  ? 'rounded-md'
                  : index === 0
                    ? 'rounded-s-md'
                    : index === data.length - 1
                      ? 'rounded-e-md'
                      : 'rounded-none'
              }`}
            >
              {!isWaste && (
                <Tooltip
                  title={`${optimizationDate} - ${diameter} - ${item}`}
                  color="white"
                  overlayInnerStyle={{ color: 'black' }}
                  className="text-wrap"
                >
                  {optimizationDate} - {diameter} - {item}
                </Tooltip>
              )}
              <Tooltip
                title={item}
                color="white"
                overlayInnerStyle={{ color: 'black' }}
                className="text-wrap"
              >
                <div
                  className="font-bold"
                  style={{ fontSize: '8px', color: '#333' }}
                >
                  {item}
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>
    );
  };

  // Extract unique diameters dynamically from the data
  const uniqueDiameters = Array.from(
    new Set(bbsAlgorithmResult?.map((item) => item.diameter)),
  );

  useEffect(() => {
    // Set the default diameter as the smallest diameter when the component mounts
    const smallestDiameter = Math.min(...uniqueDiameters.map(Number));
    setDiameterFilter(smallestDiameter.toString());

    // Filter data based on diameter selection
    const filtered = bbsAlgorithmResult.filter(
      (item) => item.diameter === smallestDiameter.toString(),
    );
    console.log('filtered in table:', filtered);
    setFilteredData(filtered);
  }, [bbsAlgorithmResult]);

  useEffect(() => {
    const filtered = bbsAlgorithmResult.filter(
      (item) => item.diameter === diameterFilter,
    );
    setFilteredData(filtered);
  }, [diameterFilter]);

  const handleDiameterChange = (value) => {
    setDiameterFilter(value);
  };

  const menu = (
    <Menu onClick={(e) => handleDiameterChange(e.key)}>
      {uniqueDiameters.map((diameter) => (
        <Menu.Item key={diameter}>{diameter}</Menu.Item>
      ))}
    </Menu>
  );
  console.log('>>', filteredData);
  const columns = [
    {
      title: 'Pattern No.',
      dataIndex: 'pattern',
      key: 'pattern',
      width: '50px',
      render: (_, __, index) => <span>{index + 1}</span>,
    },
    {
      title: (
        <Dropdown overlay={menu} trigger={['click']}>
          <Space>
            <span style={{ fontWeight: 'semi-bold', color: '#1c4e9d' }}>
              {`Size(mm) ${diameterFilter} `} <DownOutlined />{' '}
              {/* ${diameterFilter} */}
            </span>
          </Space>
        </Dropdown>
      ),
      dataIndex: 'diameter',
      key: 'diameter',
      width: '50px',
      render: (_, record) => <span>{diameterFilter}</span>,
    },
    {
      title: 'Repetition',
      dataIndex: 'repetition',
      key: 'repetition',
      width: '50px',
      render: (_, record) => <span>{record.repetition}</span>,
    },
    // {
    //   title: 'Waste',
    //   dataIndex: 'waste',
    //   key: 'waste',
    //   width: '100px',
    //   render: (_, record) => <span>{record?.waste?.toFixed(2)}</span>,
    // },
    // {
    //   title: 'Waste Percentage',
    //   dataIndex: 'waste_percentage',
    //   key: 'waste_percentage',
    //   width: '100px',
    //   render: (_, record) => (
    //     <span>{record?.waste_percentage?.toFixed(2)}</span>
    //   ),
    // },

    {
      title: 'Cutting Pattern',
      dataIndex: 'cutting_pattern',
      key: 'cutting_pattern',
      // width: '300px',
      render: (_, record) => (
        <div className="relative w-[800px]">
          <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100  rounded-md">
            {/* Scrollable container */}
            <div className="flex min-w-max">
              <VisualizationBar
                data={[...record.cutting_pattern, record.waste]}
                optimizationDate={dayjs(optimizationDate).format('YYYY-MM-DD')}
                diameter={filteredData[0]?.diameter}
              />
            </div>
          </div>
          {/* <div
            className="flex flex-col items-center justify-center"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {record.cutting_pattern?.map((cutLength, index) => (
                <div
                  className="bg-slate-200"
                  key={index}
                  style={{ fontSize: '8px', color: '#333', marginRight: '5px' }}
                >
                  {cutLength}
                </div>
              ))}
            </div>
          </div> */}
        </div>
      ),
    },
  ];

  const dataSource = filteredData[0]?.response?.patterns || [];
  return (
    <div style={{ width: '100%' }}>
      {console.log('bbs-algorithm-result: in mainpage: ', bbsAlgorithmResult)}
      <Table
        columns={columns?.map((column) => ({
          ...column,
          align: 'center', // Apply center alignment to all columns
        }))}
        dataSource={dataSource}
        rowKey="pattern"
        style={{ width: '100%', marginTop: '-15px' }}
        pagination={false}
        scroll={{ x: 'max-content' }}
        rowClassName={(record, index) =>
          index % 2 === 0 ? 'even-row' : 'odd-row'
        }
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  backgroundColor: '#F3F8FF',
                  color: '#1C4E9D',
                  textAlign: 'center',
                }}
              />
            ),
          },
        }}
      />
    </div>
  );
};

export default VisualizationTable;
